var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxygenBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "oxygenbold",
    horizAdvX: 1359
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1638,
    descent: -410
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 541
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1183,
    d: "M10 942v156h173v33q1 75 6.5 127t20.5 102t42 81.5t70.5 56t106.5 35.5t148 11h68l22 -190h-70q-53 0 -84.5 -9.5t-48 -34t-21.5 -56.5t-5 -88v-68h625v-1098h-254v942h-371v-942h-255v942h-173zM809 1259v224h255v-224h-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1395,
    d: "M10 942v156h173v46q2 207 101.5 301.5t324.5 94.5q106 0 312 -22t213 -22v-1072q0 -51 1.5 -81.5t7.5 -61.5t16.5 -47t29.5 -29.5t46.5 -18.5t66.5 -5q12 0 64 4l13 -184q-2 0 -28.5 -4.5t-54.5 -7t-62 -2.5q-66 0 -118 11.5t-89 31t-63.5 52.5t-43 69.5t-25.5 89 t-12.5 103.5t-3.5 120v873q-10 1 -58 5.5t-90 7t-81 2.5q-124 0 -167.5 -41t-44.5 -145v-68h237v-156h-237v-942h-255v942h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 541
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 541
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 541
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 446,
    d: "M69 134q0 63 45 109t110 46q64 0 108.5 -46t44.5 -109q0 -62 -44.5 -107t-108.5 -45q-65 0 -110 45t-45 107zM108 1162v296h241v-296l-90 -713h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 784,
    d: "M108 1470h224l-30 -515h-159zM454 1470h223l-31 -515h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1192,
    d: "M53 404l8 179h227l55 315h-212l8 179h236l80 381h195l-76 -381h193l74 381h190l-75 -381h181l-12 -178h-202l-60 -316h195l-10 -179h-215l-80 -419h-196l79 419h-190l-79 -419h-189l77 419h-202zM478 583h194l61 316h-193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1194,
    d: "M94 102l66 215q198 -109 398 -115v434q-120 35 -162 52q-295 104 -295 388q0 185 124 292t333 121v154h98v-152q240 -7 419 -109l-82 -198q-180 81 -337 87v-393q8 -3 24 -8t35.5 -11t26.5 -8q201 -66 287.5 -164t86.5 -273q0 -189 -123 -300t-337 -130v-196h-98l-2 192 q-255 3 -462 122zM381 1088q0 -122 121 -159q14 -5 56 -18v356q-85 -11 -129 -54t-48 -125zM656 208q185 30 185 208q0 128 -155 180q-3 2 -15.5 5.5t-14.5 4.5v-398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1790,
    d: "M54 1067q0 170 96.5 282t258.5 112q169 0 266 -110t97 -281q0 -169 -101 -281t-267 -112q-163 0 -256.5 110t-93.5 280zM234 1067q0 -105 43.5 -168t129.5 -63q87 0 131.5 65t44.5 168q0 105 -44.5 170t-130.5 65t-130 -66t-44 -171zM307 -32l901 1482l220 -1l-908 -1481 h-213zM1008 372q0 394 363 394q179 0 274.5 -108.5t95.5 -281.5q0 -169 -97.5 -281t-264.5 -112q-172 0 -271.5 110.5t-99.5 278.5zM1198 372q0 -104 46.5 -167t137.5 -63q90 0 135.5 65.5t45.5 169.5t-48.5 167.5t-144.5 63.5t-134 -63t-38 -173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1436,
    d: "M58 404q0 64 19 120t48.5 97.5t76 81.5t90.5 68t103 60q-41 46 -63 73.5t-49.5 70.5t-40 85.5t-12.5 89.5q0 110 54 187.5t138.5 112.5t189.5 35q74 0 142.5 -18.5t126.5 -55.5t93 -99.5t35 -143.5q0 -68 -27 -127.5t-76.5 -106.5t-101 -81t-117.5 -67l350 -382 q81 88 154 230l170 -113q-78 -151 -180 -265l207 -219q-7 -2 -105.5 -26.5t-104.5 -26.5l-142 149q-205 -156 -456 -156q-106 0 -197.5 25t-165.5 74.5t-116.5 133.5t-42.5 194zM289 426q0 -127 83 -192.5t215 -65.5q86 0 168 28.5t144 79.5q-19 20 -196 212.5t-195 212.5 q-42 -24 -68.5 -40.5t-58.5 -43t-49.5 -52t-30 -61.5t-12.5 -78zM451 1160q0 -112 120 -236q47 25 77.5 45t64.5 50t51 67t17 80q0 73 -45 111t-117 38q-77 0 -122.5 -39t-45.5 -116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 440,
    d: "M105 1464h214l-27 -535h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 650,
    d: "M93 597q0 496 282 891h236q-100 -143 -185 -393.5t-85 -495.5q0 -240 85.5 -488t183.5 -387h-234q-283 387 -283 873z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 650,
    d: "M40 1488h235q283 -399 283 -891q0 -484 -284 -873h-233q60 86 118 215.5t104 312t46 347.5q0 244 -84.5 494.5t-184.5 394.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1104,
    d: "M71 1059l64 207l337 -133l-35 371h228l-35 -371l341 129l61 -208l-344 -72q5 -7 119.5 -149t125.5 -157q-6 -4 -100.5 -57t-101.5 -57l-182 323l-174 -323l-204 114l242 306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1180,
    d: "M83 554v191h410v408h198v-408h407v-191h-408v-408h-198v408h-409z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 508,
    d: "M64 -283q57 277 94 515h244l-3 -49q-65 -226 -158 -466h-177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 677,
    d: "M70 445v204h536v-204h-536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 473,
    d: "M90 134q0 63 44.5 109t110.5 46q64 0 108 -46t44 -109q0 -62 -44 -107t-108 -45q-65 0 -110 45t-45 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 949,
    d: "M52 -189l622 1678h218l-627 -1678h-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1296,
    d: "M98 732q0 125 18 234.5t60 207t104.5 166.5t156.5 109.5t212 40.5t212 -40.5t156 -110t103.5 -167t59.5 -206.5t18 -234q0 -123 -17.5 -231t-58.5 -205.5t-103 -166.5t-156.5 -109.5t-213.5 -40.5t-214 40.5t-157 110t-103.5 166.5t-59 205t-17.5 231zM369 744 q0 -114 13 -207t43 -175.5t87 -128.5t137 -46t136.5 46t86 127.5t42.5 174t13 205.5q0 542 -278 542q-276 0 -280 -538z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 686,
    d: "M43 1110v200q24 11 152 75.5t141 73.5h220v-1458h-253v1219q-14 -9 -129.5 -57.5t-130.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1054,
    d: "M75 1358q150 132 422 132q216 0 347.5 -108.5t131.5 -306.5q0 -140 -74.5 -267t-203.5 -261l-330 -350h591l-18 -197h-856l-6 216l463 524q86 92 125.5 169.5t39.5 163.5q0 95 -62 151.5t-163 56.5q-93 0 -183.5 -34.5t-148.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1078,
    d: "M62 1378q182 112 432 112q209 0 341.5 -110t132.5 -282q0 -120 -61.5 -204.5t-178.5 -123.5q134 -26 207.5 -129t73.5 -243q0 -133 -71 -229.5t-188 -143t-265 -46.5q-129 0 -242.5 33.5t-179.5 90.5l72 189q55 -46 152 -75.5t199 -29.5q115 0 185.5 62t70.5 162 q0 62 -19.5 107t-51.5 72t-85.5 43.5t-109.5 22.5t-135 7q-3 0 -29 0.5t-29 0.5v202h56q87 0 149.5 9t116 31t81 65t27.5 106q0 85 -64 145t-180 60q-188 0 -335 -94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1253,
    d: "M92 325v178l593 955h333v-935h180l-13 -198h-167v-325h-265v325h-661zM352 522h401v680z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1138,
    d: "M105 119l80 188q19 -15 55.5 -37.5t118 -51.5t156.5 -29q140 0 212 78t72 204q0 119 -65.5 191t-169.5 72q-124 0 -222 -108l-175 34l38 798h796l-15 -206h-549q0 -18 -6.5 -180.5t-7.5 -181.5q88 47 185 47q202 0 325.5 -130t123.5 -339q0 -222 -135.5 -355.5 t-379.5 -133.5q-99 0 -204 32.5t-160 62t-73 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1205,
    d: "M65 463q0 70 15 134t46 125t62 108t80 112l416 525h310l-454 -573q73 25 122 25q215 0 352 -128.5t137 -334.5q0 -214 -150 -345.5t-386 -131.5q-244 0 -397 133t-153 351zM334 451q0 -123 70 -197.5t199 -74.5q132 0 206.5 75.5t74.5 198.5q0 129 -70 203.5t-208 74.5 q-140 0 -206 -75t-66 -205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1036,
    d: "M75 1258l2 201h900v-157l-472 -1302h-268l442 1258h-604z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1151,
    d: "M64 389q0 263 259 378q-231 110 -231 344q0 92 38 165t104.5 119.5t154 70.5t189.5 24q212 0 348.5 -99t136.5 -280q0 -231 -214 -344q241 -117 241 -379q0 -130 -70.5 -224.5t-185 -139.5t-256.5 -45q-143 0 -257.5 45.5t-185.5 140t-71 224.5zM308 393q0 -110 72 -171 t198 -61t197 61t71 172q0 110 -74 182t-194 103q-123 -31 -196.5 -103t-73.5 -183zM322 1110q0 -108 68 -178t188 -97q123 28 189 97.5t66 177.5q0 90 -72 145t-183 55q-110 0 -183 -55t-73 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1215,
    d: "M82 1020q0 214 148.5 342t385.5 128q245 0 397 -131.5t152 -349.5q0 -126 -48 -229t-141 -230l-414 -550h-319l444 578q-67 -23 -119 -23q-215 0 -350.5 129.5t-135.5 335.5zM345 1019q0 -130 70.5 -205t208.5 -75q139 0 205.5 77t66.5 208q0 123 -69 195t-198 72 q-133 0 -208.5 -75t-75.5 -197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 460,
    d: "M100 -6v265h265v-265h-265zM100 841v265h265v-265h-265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 448,
    d: "M107 -322l56 568h226l-124 -568h-158zM125 841v264h264v-264h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1196,
    d: "M115 645v124l967 482v-206l-705 -333l704 -311v-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1202,
    d: "M93 357v191h1018v-191h-1018zM93 754v193h1018v-193h-1018z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1196,
    d: "M119 197v206l704 309l-704 335v206l967 -484v-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 887,
    d: "M51 1384q82 53 170 79.5t206 26.5q71 0 138.5 -21.5t124 -62t91 -107.5t34.5 -151q0 -68 -24 -134t-66 -130t-88.5 -125t-104 -145.5t-98.5 -165.5h-111q10 79 43 160t72.5 146t78 126t64 121.5t25.5 111.5q-1 88 -55.5 139t-151.5 51q-62 0 -120 -15.5t-88.5 -30.5 t-69.5 -39zM221 134q0 63 45 109t110 46q64 0 108 -46t44 -109q0 -62 -44 -107t-108 -45q-65 0 -110 45t-45 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1699,
    d: "M68 590q0 171 62.5 321.5t171.5 258t262.5 169t328.5 61.5q208 0 376.5 -87t266 -247t97.5 -364q0 -117 -37 -220t-98 -173.5t-141 -111.5t-164 -41q-83 0 -133 53t-52 166q-38 -90 -107.5 -147t-151.5 -57q-138 0 -216 88t-78 233q0 143 59 266.5t168 198.5t244 75 q138 0 316 -64q-13 -68 -42.5 -206.5t-46 -230.5t-16.5 -143t18.5 -70t59.5 -19q69 0 130.5 61t96.5 154.5t35 190.5q0 164 -75.5 290t-208.5 193t-301 67q-135 0 -248.5 -45t-187.5 -116t-126 -162t-75 -180.5t-23 -173.5q0 -152 52 -275t142.5 -202t209 -121t253.5 -42 q293 0 502 154l55 -108q-231 -189 -555 -189q-241 0 -427.5 97t-291 278.5t-104.5 419.5zM632 506q0 -84 29.5 -139t90.5 -55q192 0 277 436q12 64 25 151q-55 11 -113 11q-84 0 -156.5 -61t-112.5 -154t-40 -189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM494 616h376q-180 577 -185 596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1333,
    d: "M158 0v1465h457q291 0 434 -85t143 -283q0 -32 -4 -63t-18 -70.5t-37 -71.5t-64 -62.5t-96 -47.5q136 -33 208 -126.5t72 -230.5q0 -207 -146.5 -316t-405.5 -109h-543zM429 196h235q312 0 312 244q0 123 -78 177t-241 54h-228v-475zM429 860h232q269 0 269 205 q0 115 -77.5 158t-246.5 43h-177v-406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1301,
    d: "M100 739q0 338 196.5 542.5t514.5 204.5q257 0 435 -119l-85 -205q-171 105 -344 105q-202 0 -319.5 -145.5t-117.5 -390.5q0 -254 113.5 -393t323.5 -139q184 0 365 92l36 -212q-168 -100 -421 -100q-321 0 -509 202t-188 558z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1514,
    d: "M159 0v1465h424q192 0 344 -44t261.5 -132.5t168 -228t58.5 -322.5q0 -355 -214 -546.5t-593 -191.5h-449zM430 217h194q251 0 382 131.5t131 383.5q0 270 -135 392.5t-407 122.5h-165v-1030z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1152,
    d: "M158 0v1465h888l-11 -215h-606v-378h576v-215h-576v-441h628l-9 -216h-890z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1103,
    d: "M158 0v1465h867l-10 -215h-588v-416h559v-213h-559v-621h-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1466,
    d: "M100 734q0 223 88 392.5t259 264.5t404 95q267 0 458 -115l-88 -202q-182 98 -365 98q-222 0 -349 -144t-127 -392q0 -246 113 -389t331 -143q140 0 254 44v340h-307l2 213h560v-707q-136 -56 -257.5 -83t-263.5 -27q-335 0 -523.5 202t-188.5 553z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1520,
    d: "M158 0v1465h271v-599h662v599h271v-1465h-271v652h-662v-652h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 602,
    d: "M165 0v1465h271v-1465h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 633,
    d: "M-84 -108q48 -8 105 -8q111 0 150 57t39 188v1340h272v-1322q0 -126 -22.5 -212.5t-76 -147t-142 -88.5t-219.5 -28q-55 0 -95 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1348,
    d: "M157 0v1465h272v-660q71 94 290.5 351t261.5 309h321l-554 -659l589 -806h-318l-478 657l-112 -94v-563h-272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1071,
    d: "M158 0v1465h271v-1249h613l-8 -216h-876z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1841,
    d: "M158 0v1465h320l443 -1058l446 1058h316v-1465h-250v724l8 415l-37 -110l-375 -929h-232l-367 934l-37 110l9 -424v-720h-244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1554,
    d: "M158 0v1465h288q78 -122 317 -492t291 -450q15 -23 51.5 -77.5t51.5 -77.5q-7 343 -7 356v741h247v-1465h-292l-661 1030l-48 79q8 -264 8 -371v-738h-246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -351 -192 -552t-522 -201q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1245,
    d: "M151 0v1469h488q173 0 296 -44.5t194.5 -144.5t71.5 -251q0 -105 -27 -186.5t-89 -148t-174.5 -102.5t-271.5 -36q-136 0 -221 8v-564h-267zM418 754q12 -2 192 -2q83 0 144.5 16t96 41t55 62t27 71.5t6.5 77.5q0 121 -78 184t-220 63h-223v-513z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -252 -101 -429.5t-286 -259.5q153 -248 286 -370l-174 -151q-83 60 -187.5 198t-170.5 263q-52 -4 -81 -4q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5 q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1394,
    d: "M151 0v1469h543q111 0 192.5 -10t155 -36.5t119 -71.5t72 -117.5t26.5 -171.5q0 -292 -265 -384q54 -61 134 -226l218 -452h-296l-171 383q-97 206 -120 244q-17 1 -113 1l-227 2v-630h-268zM419 825q15 0 149 -0.5t150 -0.5q156 0 224 55.5t68 178.5q0 108 -69 159 t-211 51h-311v-443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1189,
    d: "M94 102l66 215q94 -52 204.5 -84t215.5 -32q129 0 195 55.5t66 159.5q0 138 -184 191q-13 4 -73 21.5t-112.5 34t-75.5 25.5q-295 104 -295 388q0 199 141.5 307t375.5 108q265 0 457 -109l-82 -198q-196 88 -364 88q-121 0 -182.5 -42.5t-65.5 -141.5q0 -122 121 -159 q24 -9 118 -39t122 -39q201 -66 287.5 -164t86.5 -273q0 -209 -148 -321.5t-399 -112.5q-265 0 -475 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1152,
    d: "M14 1248v217h1124v-217h-425v-1248h-272v1248h-427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1468,
    d: "M144 527v938h272v-915q0 -183 74.5 -267t244.5 -84q167 0 242 84.5t75 267.5v914h271v-940q0 -259 -152 -402.5t-441 -143.5q-288 0 -437 143.5t-149 404.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1321,
    d: "M-6 1465h279l310 -905q18 -47 83 -275q4 16 37 131.5t43 141.5q12 34 152 451.5t153 455.5h276l-526 -1465h-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 2051,
    d: "M10 1465h270l284 -1140l334 1133h259l317 -1137l290 1144h270l-410 -1465h-281l-313 1073l-343 -1073h-279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1337,
    d: "M-11 0l513 750l-475 715h305l345 -546l355 546h289l-485 -719l511 -746h-313l-370 570l-378 -570h-297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1256,
    d: "M-15 1465h294l349 -634l351 634h290l-505 -879v-586h-272v581z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1209,
    d: "M62 0v174l773 1075h-746v216h1066v-197l-759 -1052h764l-1 -216h-1097z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 651,
    d: "M135 -266v1773h464v-180h-212v-1412h212v-181h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 903,
    d: "M30 1462h231l617 -1522h-229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 651,
    d: "M52 -85h211v1412h-211v180h464v-1773h-464v181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 1154,
    d: "M36 549l462 922h129l493 -922h-209l-347 668l-319 -668h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1155,
    d: "M72 -144h1014v-174h-1014v174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 514,
    d: "M-8 1578h306l188 -383h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM336 310q0 -70 41 -107.5t117 -37.5q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1258,
    d: "M133 1v1503l262 17v-340q0 -99 -6 -225q130 170 339 170q210 0 329.5 -156t119.5 -408q0 -262 -123.5 -422.5t-331.5 -160.5q-112 0 -203.5 49.5t-132.5 112.5l-26 -140h-227zM393 570q0 -202 67 -297t199 -95q117 0 187 99t70 281q0 183 -68.5 277t-185.5 94 q-266 0 -269 -359z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1008,
    d: "M81 558q0 270 147.5 419t388.5 149q193 0 326 -83l-62 -187q-136 71 -253 71q-133 0 -209.5 -95t-76.5 -277q0 -184 75.5 -280t213.5 -96q144 0 277 85l25 -199q-69 -46 -143 -66t-176 -20q-252 0 -392.5 150t-140.5 429z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1259,
    d: "M81 559q0 256 122.5 411.5t337.5 155.5q234 0 331 -166q-10 98 -10 189v355l262 17v-1521h-227l-29 150q-17 -27 -31.5 -46.5t-42.5 -45t-60.5 -41t-82 -27t-109.5 -11.5q-215 0 -338 158t-123 422zM342 553q0 -183 70.5 -279t191.5 -96q264 0 268 359q0 203 -68 296 t-203 93q-118 0 -188.5 -94.5t-70.5 -278.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1157,
    d: "M81 553q0 262 139 417t379 156q227 0 352.5 -142t125.5 -377q0 -17 -0.5 -55t-0.5 -56h-731q4 -154 84.5 -238.5t221.5 -84.5q180 0 346 94l37 -186q-165 -102 -393 -102q-265 0 -412.5 152.5t-147.5 421.5zM350 661h480q0 134 -61 206t-169 72q-101 0 -170.5 -70 t-79.5 -208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 760,
    d: "M29 925l17 154l157 20v61q0 100 18.5 171t60.5 121.5t112.5 75t173.5 24.5q100 0 204 -19l-23 -195q-82 11 -129 11q-84 0 -119.5 -40.5t-35.5 -134.5v-75h258v-174h-258v-925h-262v925h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1267,
    d: "M75 562q0 132 39 240.5t106 178.5t154.5 107.5t186.5 37.5q221 0 329 -161l18 134h234v-1021q0 -82 -8 -147.5t-28 -126t-52.5 -105.5t-81.5 -82t-115.5 -60.5t-154.5 -36t-198 -12.5h-151l-15 212h133q231 0 323 61.5t92 225.5q0 67 -6 145q-26 -36 -49.5 -59.5 t-59 -46.5t-85 -34.5t-112.5 -11.5q-218 0 -358.5 157t-140.5 405zM337 562q0 -161 74.5 -270t204.5 -109q271 0 274 363v38q-2 163 -68 252t-193 90q-144 0 -218 -98.5t-74 -265.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1253,
    d: "M133 0v1504l262 17v-317q0 -23 -3 -127.5t-3 -106.5q131 156 352 156q184 0 285.5 -105.5t101.5 -324.5v-696h-262v667q0 135 -43 198t-146 63q-88 0 -156 -44.5t-102 -114.5q-24 -92 -24 -240v-529h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 541,
    d: "M139 0v1099h262v-1099h-262zM139 1259v224h263v-224h-263z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 527,
    d: "M-77 -233h58q50 0 82 7.5t53 21t31 41.5t13.5 60.5t3.5 86.5v1115h262v-1073q0 -82 -6.5 -141t-23.5 -112.5t-46.5 -88.5t-75.5 -61.5t-111 -38t-152 -11.5h-59zM164 1259v224h262v-224h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1173,
    d: "M133 0v1504l262 17v-675l-6 -222q1 1 20.5 20t21.5 21q55 65 119.5 134t163 169t128.5 131h312l-452 -468l481 -631h-317l-362 499l-109 -86v-413h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 700,
    d: "M136 433v1071l262 17v-1083q0 -148 35 -200.5t136 -52.5q50 0 127 11l7 -187q-1 0 -24.5 -5t-45 -8.5t-54.5 -7t-61 -3.5q-113 0 -187.5 26.5t-117.5 84.5t-60 138t-17 199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1911,
    d: "M133 0v1099h212l30 -140q20 25 38.5 44.5t51 44t69 40.5t90 27t114.5 11q131 0 209.5 -53t110.5 -124q59 85 153 131t209 46q189 0 277.5 -107t88.5 -317v-702h-263v624q0 161 -35.5 232.5t-135.5 71.5q-153 0 -220 -138q-28 -61 -38 -147v-643h-262v636q0 147 -39 219 t-141 72q-83 0 -143 -42t-91 -110q-23 -101 -23 -242v-533h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1254,
    d: "M133 0v1099h211l29 -139q168 166 373 166q192 0 287.5 -110.5t95.5 -320.5v-695h-263v663q-1 133 -43 199t-151 66q-85 0 -155.5 -43.5t-102.5 -109.5q-19 -78 -19 -240v-535h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1222,
    d: "M81 553q0 266 140 419.5t395 153.5q246 0 385.5 -156.5t139.5 -416.5q0 -263 -141 -418.5t-395 -155.5q-244 0 -384 158t-140 416zM342 552q0 -180 68 -277t202 -97q133 0 200 97t67 278q0 183 -67 279t-202 96q-133 0 -200.5 -96.5t-67.5 -279.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1256,
    d: "M133 -457v1556h225l28 -154q54 87 143.5 134.5t199.5 47.5q135 0 237.5 -75t155.5 -204.5t53 -292.5q0 -255 -123.5 -415.5t-334.5 -160.5q-104 0 -188.5 41.5t-141.5 112.5q8 -144 8 -162v-415zM393 574q0 -204 67.5 -299.5t200.5 -95.5q117 0 184.5 98t67.5 280 q0 185 -68 278t-189 93q-260 0 -263 -354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1259,
    d: "M82 555q0 255 123 413t344 158q217 0 325 -167l21 140h230v-1543l-263 -13v465q0 69 7 142q-104 -172 -314 -172q-213 0 -343 160t-130 417zM343 552q0 -184 70 -279.5t193 -95.5q128 0 196 86t70 272q0 204 -67.5 297.5t-201.5 93.5q-121 0 -190.5 -94t-69.5 -280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 798,
    d: "M134 0v1099h220l34 -168q108 173 313 173q43 0 70 -4l-4 -219q-40 6 -83 6q-145 0 -216.5 -77t-71.5 -214v-596h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 985,
    d: "M95 63l27 197q66 -36 168 -64.5t186 -28.5q87 0 135.5 32.5t49.5 95.5q0 57 -45.5 90t-173.5 82q-44 16 -57 21q-152 59 -219 131.5t-67 196.5q0 150 108.5 230t302.5 80q210 0 369 -79l-65 -181q-157 73 -299 73q-79 0 -123.5 -26.5t-44.5 -80.5q0 -51 43 -79.5 t168 -74.5q4 -1 26 -9t34 -13q151 -55 222 -131.5t71 -199.5q-1 -165 -112 -255t-315 -90q-243 0 -389 83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 803,
    d: "M12 940l10 142l188 17l84 298l160 1v-299h273v-159h-273v-524q0 -125 36 -178t133 -53q57 0 122 10l7 -188q-2 0 -24.5 -4.5t-43 -8t-52.5 -6.5t-60 -3q-112 0 -186.5 26.5t-116.5 83.5t-59.5 134.5t-17.5 191.5v519h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1163,
    d: "M106 400v699h263v-689q0 -123 51.5 -178t163.5 -55q110 0 160.5 54.5t50.5 178.5v689h262v-699q0 -206 -131 -313.5t-345 -107.5t-344.5 107t-130.5 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1125,
    d: "M3 1099h278q16 -45 101.5 -279.5t113.5 -319.5q57 -166 82 -251q0 1 17 65t32.5 120.5t19.5 68.5q1 2 91.5 276t107.5 320h276l-416 -1099h-265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1713,
    d: "M13 1099h267l211 -806q7 23 114 393t121 413h269q13 -42 115 -409t110 -394l217 803h263l-344 -1099h-261q-13 43 -121.5 435t-117.5 423q-20 -73 -127.5 -440t-124.5 -418h-258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1158,
    d: "M21 0l391 563l-372 536h297l244 -374l251 374h292l-375 -535l388 -564h-300l-256 399l-264 -399h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1116,
    d: "M-6 1099h280l289 -797q32 119 143.5 442t122.5 355h280q-457 -1208 -461 -1218q-71 -185 -179 -264.5t-278 -79.5q-64 0 -136 8l-13 203q46 -5 117 -5q91 0 146 36t91 128q4 10 40 113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 977,
    d: "M65 0v159l544 758h-518v182h808v-179l-515 -729h533v-191h-852z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 786,
    d: "M52 505v214q93 1 141 21.5t66 64t18 125.5v291q0 85 26 141.5t82 89t132 46t186 13.5v-200q-107 -1 -140.5 -37t-33.5 -137v-269q-1 -101 -50 -158.5t-162 -99.5q212 -44 212 -250v-272q0 -101 33.5 -137t140.5 -37v-201q-226 0 -326 64.5t-100 235.5v277 q0 120 -47 167.5t-178 47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 759,
    d: "M278 -380v1918h203v-1918h-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 787,
    d: "M85 -86q107 1 140.5 36.5t33.5 137.5v272q0 104 51.5 161.5t160.5 89.5q-109 34 -160 94.5t-52 162.5v269q0 101 -33.5 137t-140.5 37v200q113 0 188.5 -13t131 -46.5t81 -92t25.5 -147.5v-283q0 -120 45.5 -164.5t180.5 -45.5v-214q-132 0 -179 -46.5t-47 -168.5v-286 q0 -166 -100 -228.5t-326 -62.5v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1297,
    d: "M130 616q96 195 287 195q109 0 264 -66q146 -64 219 -64q60 0 115 32.5t119 103.5l71 -135q-43 -80 -131.5 -138t-190.5 -58q-65 0 -122 17.5t-143 56.5q-67 31 -112.5 45.5t-97.5 14.5q-122 0 -201 -149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 446,
    d: "M69 970q0 62 44.5 107t108.5 45q65 0 110 -45t45 -107q0 -63 -45 -109t-110 -46q-64 0 -108.5 46t-44.5 109zM97 -58l90 713h66l85 -713v-296h-241v296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1082,
    d: "M82 636q0 125 39 227.5t106.5 169.5t155.5 106t190 45v218h101v-221q158 -13 260 -91l-45 -174q-38 26 -97.5 48t-117.5 28v-750q116 9 218 81l52 -175q-119 -84 -270 -94v-256h-101v256q-224 17 -357.5 169.5t-133.5 412.5zM329 628q0 -166 64.5 -262.5t179.5 -118.5 v742q-111 -20 -177.5 -111t-66.5 -250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 1149,
    d: "M67 659v179h185v105q0 123 24.5 220t77 171t141 113.5t208.5 39.5q218 0 385 -140l-103 -169q-74 49 -137.5 74.5t-134.5 25.5q-212 0 -212 -261v-179h391v-179h-391v-150q0 -200 -112 -296q8 1 147 1h569l-8 -214h-1012l-16 190q101 43 142 103.5t41 175.5v190h-185z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 1162,
    d: "M51 1144l95 92l183 -173q111 86 252 86t253 -88l186 175l91 -94l-184 -173q75 -108 75 -237q0 -131 -74 -237l181 -172l-89 -94l-186 173q-113 -85 -253 -85q-147 0 -254 84l-181 -171l-94 92l185 173q-76 107 -76 237q0 128 76 237zM299 732q0 -115 82.5 -196t199.5 -81 q118 0 200.5 81t82.5 196t-83 196.5t-200 81.5q-116 0 -199 -82t-83 -196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 1194,
    d: "M-44 1459h284l359 -621l359 621h279l-428 -724h276v-152h-351v-141h351v-153h-351v-289h-263v289h-347v153h347v141h-346v152h267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 817,
    d: "M306 340h203v-719h-203v719zM306 820v718h203v-718h-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1034,
    d: "M133 776q0 81 39.5 145t103.5 105q-126 88 -126 235q0 140 103.5 214t278.5 76q175 5 340 -58q-1 -7 -18 -92.5t-18 -91.5q-139 61 -280 61q-176 0 -176 -106q0 -50 47 -86.5t157 -81.5q77 -31 132.5 -61.5t102.5 -70t71 -89t24 -108.5q0 -164 -138 -258 q127 -85 127 -225q0 -152 -119.5 -233.5t-311.5 -81.5t-334 68v191q70 -33 161.5 -55.5t163.5 -22.5q86 0 139 25.5t61 74.5q14 52 -29 92t-164 93q-84 34 -141 65t-104 71t-69.5 91t-22.5 114zM346 802q0 -56 51.5 -101t148.5 -87q5 -2 28.5 -12t32.5 -13q96 65 96 142 q0 66 -66.5 113.5t-192.5 95.5q-45 -23 -71.5 -59.5t-26.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 772,
    d: "M78 1236v254h195v-254h-195zM499 1236v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1743,
    d: "M89 741q0 164 62.5 307.5t168 243t248 156.5t298.5 57q157 0 300.5 -57t250 -156.5t169.5 -243t63 -307.5t-63 -307.5t-169 -242.5t-249.5 -156t-300.5 -57q-156 0 -298.5 57t-248.5 156t-168.5 242.5t-62.5 307.5zM205 742q0 -182 84.5 -333.5t237 -241t340.5 -89.5 q189 0 342.5 89t238.5 240.5t85 333.5q0 181 -85 332.5t-239 241t-343 89.5q-187 0 -339.5 -89.5t-237 -240.5t-84.5 -332zM392 743q0 137 57.5 250t163.5 179t240 66q185 0 307 -82l-49 -104q-113 66 -247 66q-149 0 -238 -103.5t-89 -271.5q0 -167 90 -268t242 -101 q133 0 248 66l44 -104q-124 -82 -307 -82q-200 0 -331 138.5t-131 350.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 757,
    d: "M75 963q0 48 16.5 86t48.5 62.5t68 41.5t86 27.5t90 16t93 11.5q20 2 29 3v32q-1 76 -30 108.5t-94 32.5q-108 0 -249 -58l-42 110q144 78 308 78q121 0 195.5 -58.5t74.5 -187.5v-379q0 -102 1 -125h-135l-17 85q-32 -43 -94.5 -71t-124.5 -28q-96 0 -160 56t-64 157z M112 536v120h561v-120h-561zM231 968q0 -43 24 -66.5t62 -23.5q51 0 101.5 31t87.5 86v111q-50 -7 -78.5 -11.5t-65 -12t-56.5 -17t-39.5 -23t-27.5 -32t-8 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1083,
    d: "M74 546l10 43l307 398l207 -53l-280 -372l275 -372l-205 -54zM489 558l325 429l201 -53l-274 -372l270 -372l-199 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 1287,
    d: "M132 641v193h1020v-587h-191v394h-829z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 745,
    d: "M76 380v204h595v-204h-595z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1735,
    d: "M89 741q0 164 62.5 307.5t167.5 243t247 156.5t298 57q157 0 300 -57t249 -156.5t169 -243t63 -307.5t-62.5 -307.5t-168.5 -242.5t-249 -156t-300 -57q-156 0 -298 57t-247.5 156t-168 242.5t-62.5 307.5zM205 742q0 -182 84.5 -333.5t236.5 -241t339 -89.5 q189 0 342 89t237.5 240.5t84.5 333.5q0 181 -84.5 332.5t-238 241t-342.5 89.5q-187 0 -339 -89.5t-236 -240.5t-84 -332zM556 271v955h300q358 0 358 -262q0 -110 -49.5 -172t-164.5 -87q12 -15 27 -37t34.5 -54t34.5 -57.5t40.5 -71t38 -68.5t41.5 -76t38 -70h-165 q-26 46 -121 228q-98 180 -112 189h-152v-417h-148zM703 813h120q49 0 83 3t66 12.5t51 26t30 43t11 64.5q0 33 -6.5 56t-22.5 38.5t-33.5 24t-50 13t-61 5.5t-76.5 1h-111v-287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 912,
    d: "M118 1377v153h686v-153h-686z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 850,
    d: "M111 1167q0 120 85.5 204t230.5 84q143 0 229 -84t86 -204t-85.5 -208.5t-229.5 -88.5q-145 0 -230.5 88t-85.5 209zM263 1165q0 -75 49 -120.5t116 -45.5q66 0 114.5 45.5t48.5 120.5q0 73 -48.5 117t-114.5 44q-67 0 -116 -44t-49 -117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 1288,
    d: "M180 0v177h929v-177h-929zM180 636v192h364v368h199v-368h366v-192h-365v-375h-200v375h-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 834,
    d: "M135 1289q55 72 123 111t164 39q115 0 196.5 -76.5t81.5 -199.5q0 -64 -17.5 -117.5t-65 -110t-83 -90t-118.5 -104.5q-20 -17 -30 -26h315l-15 -141h-540v142q159 106 274.5 232.5t115.5 210.5q0 57 -41 90.5t-96 33.5t-110 -32t-88 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 800,
    d: "M125 685l49 126q34 -32 94 -52t110 -20q69 0 108 35t39 103q0 64 -49.5 96t-138.5 32l-77 -1v136h79q156 0 156 98q0 43 -28 69t-85 26q-53 0 -111.5 -19t-91.5 -44l-48 111q110 89 260 89q116 0 194.5 -57.5t78.5 -170.5q-3 -121 -126 -161q60 -23 102.5 -79.5 t42.5 -125.5q0 -129 -87.5 -201t-215.5 -72q-145 0 -255 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 619,
    d: "M191 1195l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1201,
    d: "M78 1144q0 92 40 159.5t113 106.5t166.5 57.5t209.5 18.5h419v-171h-82v-1466h-166v1466h-165v-1466l-194 1v932q-153 13 -247 114.5t-94 247.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 422,
    d: "M90 488v252h242v-252h-242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 589,
    d: "M62 -357l123 381h144l-58 -381h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 743,
    d: "M132 1228v148l55 27.5t101 51.5t52 29h144v-735h140v-148h-473v148h142v555q-5 -3 -80.5 -38t-80.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 865,
    d: "M69 1131q0 170 100 275.5t269 105.5q170 0 267.5 -106.5t97.5 -278.5q0 -169 -98.5 -276t-265.5 -107q-174 0 -272 106.5t-98 280.5zM245 1129q0 -107 48 -168.5t146 -61.5q94 0 142 62t48 164q0 107 -48.5 170t-145.5 63q-94 0 -142 -63t-48 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1168,
    d: "M113 190l274 372l-271 372l200 53l324 -422l-326 -429zM545 190l277 372l-272 372l203 53l318 -422l-322 -429z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 1731,
    d: "M85 1228v148q202 101 209 108h143v-735h141v-148h-474v148h142v555q-5 -3 -81 -38.5t-80 -37.5zM305 0l1022 1471h194l-1015 -1471h-201zM985 182v142l387 541h175v-547h115l2 -136h-118l-1 -172h-157v172h-403zM1176 318h210q0 321 1 328z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 1805,
    d: "M106 1228v148q16 8 95.5 54.5t86.5 53.5h170v-751h141v-132h-474v132h142v588q-43 -28 -161 -93zM310 0l1021 1471h198l-1019 -1471h-200zM1126 704q43 65 121 98t177 33q117 0 201.5 -74.5t84.5 -199.5q0 -44 -8.5 -82.5t-31 -76.5t-42.5 -65.5t-62 -66.5t-69 -62.5 t-83 -69.5q-26 -22 -40 -33h335l-16 -134h-557l1 136q36 31 97.5 81t97 79.5t81 72t70 74t42 69t17.5 72.5q0 59 -42.5 94t-97.5 35q-59 0 -116.5 -25t-93.5 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 1683,
    d: "M79 1377q52 43 126 68.5t151 25.5q116 0 197 -58.5t81 -168.5q0 -11 -5 -30t-16.5 -45.5t-38.5 -51t-64 -36.5q61 -22 101.5 -76t40.5 -122q0 -83 -44.5 -144t-113 -89.5t-151.5 -28.5q-143 0 -255 82l49 122q33 -30 89.5 -47t108.5 -17q68 0 108 32.5t40 95.5 q0 116 -182 116l-77 -1v136h78q156 0 156 99q0 42 -29.5 66.5t-87.5 24.5q-53 0 -110.5 -17.5t-89.5 -42.5zM279 0l1020 1471h196l-1013 -1471h-203zM935 190v142l387 557h176v-564h114l2 -135h-117l-1 -179h-157v179h-404zM1126 325h210q0 326 1 340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 887,
    d: "M49 51q0 68 24 134t66 130t88.5 125t104 145.5t98.5 165.5h111q-10 -79 -43 -160t-72.5 -146t-78 -126t-64 -121.5t-25.5 -111.5q1 -88 55.5 -139t151.5 -51q62 0 120 15.5t88.5 30.5t69.5 39l70 -166q-82 -53 -170 -79.5t-206 -26.5q-71 0 -138.5 21.5t-124 62 t-91 107.5t-34.5 151zM336 1065q0 62 44 107t108 45q65 0 110 -45t45 -107q0 -63 -45 -109t-110 -46q-64 0 -108 46t-44 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM267 1991h306l188 -383h-163zM494 616h376q-180 577 -185 596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM494 616h376q-180 577 -185 596zM602 1608l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM325 1608l250 383h208l251 -383h-184l-174 218l-172 -218h-179zM494 616h376q-180 577 -185 596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM336 1608q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21q47 0 47 84h147q0 -35 -2 -62t-12 -62.5t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45 q-49 0 -50 -90h-144zM494 616h376q-180 577 -185 596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM371 1608v254h195v-254h-195zM494 616h376q-180 577 -185 596zM792 1608v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    d: "M-3 0l539 1466h295l531 -1466h-278l-145 414h-513l-146 -414h-283zM459 1677q0 83 59.5 141.5t161.5 58.5q101 0 160.5 -58.5t59.5 -141.5q0 -84 -60 -144t-160 -60t-160.5 60t-60.5 144zM494 616h376q-180 577 -185 596zM573 1676q0 -46 28 -78t79 -32t78.5 32t27.5 78 q0 45 -28 78.5t-78 33.5q-51 0 -79 -32.5t-28 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 2021,
    d: "M38 0l844 1481h1009l-15 -196h-607l33 -434h549v-196h-529l39 -459h565l-14 -196h-813l-30 375h-524l-205 -375h-302zM638 572h415l-50 663z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1301,
    d: "M100 739q0 338 196.5 542.5t514.5 204.5q257 0 435 -119l-85 -205q-171 105 -344 105q-202 0 -319.5 -145.5t-117.5 -390.5q0 -254 113.5 -393t323.5 -139q184 0 365 92l36 -212q-168 -100 -421 -100q-321 0 -509 202t-188 558zM595 -389l123 381h144l-58 -381h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1152,
    d: "M158 0v1465h888l-11 -215h-606v-378h576v-215h-576v-441h628l-9 -216h-890zM195 1991h306l188 -383h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1152,
    d: "M158 0v1465h888l-11 -215h-606v-378h576v-215h-576v-441h628l-9 -216h-890zM530 1608l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1152,
    d: "M158 0v1465h888l-11 -215h-606v-378h576v-215h-576v-441h628l-9 -216h-890zM253 1608l250 383h208l251 -383h-184l-174 218l-172 -218h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1152,
    d: "M158 0v1465h888l-11 -215h-606v-378h576v-215h-576v-441h628l-9 -216h-890zM299 1608v254h195v-254h-195zM720 1608v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 602,
    d: "M-112 1991h306l188 -383h-163zM165 0v1465h271v-1465h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 602,
    d: "M165 0v1465h271v-1465h-271zM223 1608l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 602,
    d: "M-54 1608l250 383h208l251 -383h-184l-174 218l-172 -218h-179zM165 0v1465h271v-1465h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 602,
    d: "M-8 1608v254h195v-254h-195zM165 0v1465h271v-1465h-271zM413 1608v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1524,
    d: "M6 650v179h125v634h391q919 0 919 -734q0 -176 -60 -315t-169 -229t-260 -137t-335 -47h-486v649h-125zM398 206h235q259 0 398.5 134t139.5 385q0 149 -40 252.5t-122 164.5t-195 87.5t-272 26.5h-144v-427h199v-179h-199v-444z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1554,
    d: "M158 0v1465h288q78 -122 317 -492t291 -450q15 -23 51.5 -77.5t51.5 -77.5q-7 343 -7 356v741h247v-1465h-292l-661 1030l-48 79q8 -264 8 -371v-738h-246zM434 1608q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21q47 0 47 84h147 q0 -35 -2 -62t-12 -62.5t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45q-49 0 -50 -90h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -351 -192 -552t-522 -201q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5zM400 1991h306 l188 -383h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -351 -192 -552t-522 -201q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5zM735 1608l171 383 h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -351 -192 -552t-522 -201q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5zM459 1608l250 383 h208l251 -383h-184l-174 218l-172 -218h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -351 -192 -552t-522 -201q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5zM470 1608 q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21q47 0 47 84h147q0 -35 -2 -62t-12 -62.5t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45q-49 0 -50 -90h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1626,
    d: "M99 733q0 355 192 554t523 199t522 -199.5t191 -554.5q0 -351 -192 -552t-522 -201q-331 0 -522.5 200.5t-191.5 553.5zM383 730q0 -252 109 -391t322 -139t321.5 138.5t108.5 391.5q0 256 -108.5 397t-320.5 141q-213 0 -322.5 -141.5t-109.5 -396.5zM504 1608v254h195 v-254h-195zM925 1608v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 1395,
    d: "M278 283l291 300l-291 299l134 138l301 -295l300 295l136 -139l-292 -298q41 -40 151.5 -154.5t140.5 -144.5l-136 -137l-300 294l-301 -294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1624,
    d: "M84 730q0 175 54 317.5t151 238t232 147.5t295 52q137 0 257 -38l93 213l106 -41l-93 -215q172 -89 268 -262t96 -412q0 -172 -54 -313.5t-150 -237t-231.5 -148t-295.5 -52.5q-128 0 -244 34l-98 -224l-100 42l96 221q-180 86 -281 260.5t-101 417.5zM356 726 q0 -161 51 -281t150 -185l427 984q-79 27 -169 27q-224 0 -341.5 -147t-117.5 -398zM657 213q69 -22 158 -22q225 0 342 143.5t117 391.5q0 159 -48 279t-141 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1468,
    d: "M144 527v938h272v-915q0 -183 74.5 -267t244.5 -84q167 0 242 84.5t75 267.5v914h271v-940q0 -259 -152 -402.5t-441 -143.5q-288 0 -437 143.5t-149 404.5zM321 1991h306l188 -383h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1468,
    d: "M144 527v938h272v-915q0 -183 74.5 -267t244.5 -84q167 0 242 84.5t75 267.5v914h271v-940q0 -259 -152 -402.5t-441 -143.5q-288 0 -437 143.5t-149 404.5zM656 1608l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1468,
    d: "M144 527v938h272v-915q0 -183 74.5 -267t244.5 -84q167 0 242 84.5t75 267.5v914h271v-940q0 -259 -152 -402.5t-441 -143.5q-288 0 -437 143.5t-149 404.5zM379 1608l250 383h208l251 -383h-184l-174 218l-172 -218h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1468,
    d: "M144 527v938h272v-915q0 -183 74.5 -267t244.5 -84q167 0 242 84.5t75 267.5v914h271v-940q0 -259 -152 -402.5t-441 -143.5q-288 0 -437 143.5t-149 404.5zM425 1608v254h195v-254h-195zM846 1608v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1256,
    d: "M-15 1465h294l349 -634l351 634h290l-505 -879v-586h-272v581zM549 1608l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1327,
    d: "M178 11v1443h222v-225h287q130 0 234 -24.5t184.5 -76t124.5 -138.5t44 -205q0 -212 -152.5 -330t-397.5 -118l-324 2v-328h-222zM400 1052l1 -518h336q149 0 231 68t82 191q0 135 -85 197t-255 62h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1259,
    d: "M108 0v1024q0 222 122.5 344t352.5 122q93 0 173.5 -21.5t143.5 -63.5t99 -109t36 -152q0 -61 -21 -111.5t-69.5 -95.5t-78.5 -66.5t-97 -62.5q-9 -6 -14 -9q22 -13 69 -37.5t76 -40.5t73 -43.5t72.5 -50.5t61 -56t51.5 -65.5t31.5 -74.5t12.5 -87q0 -115 -54.5 -194 t-144.5 -114.5t-209 -35.5h-292l25 179h240q84 0 130 44.5t46 121.5q0 46 -21.5 85.5t-63.5 72.5t-80.5 55.5t-98.5 54t-90 50.5q-87 53 -87 123q0 63 71 117q18 13 56.5 39.5t59.5 43t46.5 42t37.5 54t12 62.5q0 73 -56.5 114t-146.5 41q-66 0 -110 -19.5t-67.5 -58.5 t-32.5 -87.5t-9 -117.5v-1016h-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM134 1631h306l188 -383h-163zM336 310q0 -70 41 -107.5t117 -37.5q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM336 310q0 -70 41 -107.5t117 -37.5q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148zM469 1248l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM191 1248l250 383h208l251 -383h-184l-174 218l-172 -218h-179zM336 310q0 -70 41 -107.5t117 -37.5q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM202 1248q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21q47 0 47 84h147q0 -35 -2 -62t-12 -62.5t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45q-49 0 -50 -90h-144zM336 310q0 -70 41 -107.5t117 -37.5 q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM238 1248v254h195v-254h-195zM336 310q0 -70 41 -107.5t117 -37.5q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148zM659 1248v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1142,
    d: "M81 307q0 171 112 253.5t338 104.5q31 4 67 8t81 8t71 7v58q0 100 -46 145.5t-140 45.5q-134 0 -331 -75q-1 3 -33 91t-33 90q194 83 420 83q222 0 323 -96.5t101 -312.5v-717h-194q-1 4 -22 67t-21 67q-82 -80 -160.5 -117.5t-190.5 -37.5q-153 0 -247.5 84.5 t-94.5 243.5zM325 1452q0 83 59.5 141.5t161.5 58.5q101 0 160.5 -58.5t59.5 -141.5q0 -84 -60 -144t-160 -60t-160.5 60t-60.5 144zM336 310q0 -70 41 -107.5t117 -37.5q91 0 158.5 43.5t96.5 105.5v212q-3 0 -52.5 -4t-53.5 -4q-159 -14 -233 -60t-74 -148zM439 1451 q0 -46 28 -78t79 -32t78.5 32t27.5 78q0 45 -28 78.5t-78 33.5q-51 0 -79 -32.5t-28 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1679,
    d: "M72 317q0 45 8.5 81t30 64t43.5 48.5t63.5 37t75 27t93.5 20t103.5 15t118.5 13.5l85 7v117q0 103 -39.5 150.5t-146.5 51.5q-141 0 -324 -77l-49 180q175 83 389 83q126 0 211 -45.5t114 -130.5q57 79 151.5 127.5t209.5 48.5q105 0 185 -41t126.5 -113.5t69.5 -161.5 t23 -194q0 -44 -39 -64.5t-118 -23.5q-193 -11 -515 -37q7 -161 80.5 -246t210.5 -86q90 0 167 24t120 57l72 -162q-149 -108 -375 -108q-250 0 -379 159q-175 -160 -426 -160q-153 0 -246 96t-93 243zM306 305q0 -75 36.5 -115t106.5 -40q135 0 295 123q-12 24 -28.5 87.5 t-17.5 114.5q-3 0 -46 -5.5t-45 -5.5q-66 -8 -108.5 -15.5t-82.5 -19.5t-62 -28t-35 -40t-13 -56zM944 644l436 39q2 14 2 31q-2 230 -175 230q-47 0 -89 -15t-80 -48t-63 -93.5t-31 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1008,
    d: "M81 558q0 270 147.5 419t388.5 149q193 0 326 -83l-62 -187q-136 71 -253 71q-133 0 -209.5 -95t-76.5 -277q0 -184 75.5 -280t213.5 -96q144 0 277 85l25 -199q-69 -46 -143 -66t-176 -20q-252 0 -392.5 150t-140.5 429zM437 -389l123 381h144l-58 -381h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1157,
    d: "M81 553q0 262 139 417t379 156q227 0 352.5 -142t125.5 -377q0 -17 -0.5 -55t-0.5 -56h-731q4 -154 84.5 -238.5t221.5 -84.5q180 0 346 94l37 -186q-165 -102 -393 -102q-265 0 -412.5 152.5t-147.5 421.5zM166 1631h306l188 -383h-163zM350 661h480q0 134 -61 206 t-169 72q-101 0 -170.5 -70t-79.5 -208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1157,
    d: "M81 553q0 262 139 417t379 156q227 0 352.5 -142t125.5 -377q0 -17 -0.5 -55t-0.5 -56h-731q4 -154 84.5 -238.5t221.5 -84.5q180 0 346 94l37 -186q-165 -102 -393 -102q-265 0 -412.5 152.5t-147.5 421.5zM350 661h480q0 134 -61 206t-169 72q-101 0 -170.5 -70 t-79.5 -208zM501 1248l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1157,
    d: "M81 553q0 262 139 417t379 156q227 0 352.5 -142t125.5 -377q0 -17 -0.5 -55t-0.5 -56h-731q4 -154 84.5 -238.5t221.5 -84.5q180 0 346 94l37 -186q-165 -102 -393 -102q-265 0 -412.5 152.5t-147.5 421.5zM225 1248l250 383h208l251 -383h-184l-174 218l-172 -218h-179 zM350 661h480q0 134 -61 206t-169 72q-101 0 -170.5 -70t-79.5 -208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1157,
    d: "M81 553q0 262 139 417t379 156q227 0 352.5 -142t125.5 -377q0 -17 -0.5 -55t-0.5 -56h-731q4 -154 84.5 -238.5t221.5 -84.5q180 0 346 94l37 -186q-165 -102 -393 -102q-265 0 -412.5 152.5t-147.5 421.5zM270 1248v254h195v-254h-195zM350 661h480q0 134 -61 206 t-169 72q-101 0 -170.5 -70t-79.5 -208zM691 1248v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 548,
    d: "M-156 1631h306l188 -383h-163zM129 0v1098h255v-1098h-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 548,
    d: "M129 0v1098h255v-1098h-255zM179 1248l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 548,
    d: "M-98 1248l250 383h208l251 -383h-184l-174 218l-172 -218h-179zM129 0v1098h255v-1098h-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 548,
    d: "M-52 1248v254h195v-254h-195zM129 0v1098h255v-1098h-255zM369 1248v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1226,
    d: "M84 467q0 228 134.5 357t362.5 129q55 0 149 -29q-8 15 -101 126t-124 143l-249 -101l-67 134l205 83l-203 200h298l119 -113l250 100l69 -132l-211 -84q224 -248 331 -422q112 -184 112 -377q0 -105 -32.5 -194.5t-96.5 -159t-167.5 -109t-236.5 -39.5 q-243 0 -392.5 135.5t-149.5 352.5zM323 478q0 -134 80 -217t222 -83q141 0 217.5 79.5t76.5 214.5q0 136 -78.5 219t-221.5 83t-219.5 -79.5t-76.5 -216.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1254,
    d: "M133 0v1099h211l29 -139q168 166 373 166q192 0 287.5 -110.5t95.5 -320.5v-695h-263v663q-1 133 -43 199t-151 66q-85 0 -155.5 -43.5t-102.5 -109.5q-19 -78 -19 -240v-535h-262zM288 1248q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21 q47 0 47 84h147q0 -35 -2 -62t-12 -62.5t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45q-49 0 -50 -90h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1222,
    d: "M81 553q0 266 140 419.5t395 153.5q246 0 385.5 -156.5t139.5 -416.5q0 -263 -141 -418.5t-395 -155.5q-244 0 -384 158t-140 416zM198 1631h306l188 -383h-163zM342 552q0 -180 68 -277t202 -97q133 0 200 97t67 278q0 183 -67 279t-202 96q-133 0 -200.5 -96.5 t-67.5 -279.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1222,
    d: "M81 553q0 266 140 419.5t395 153.5q246 0 385.5 -156.5t139.5 -416.5q0 -263 -141 -418.5t-395 -155.5q-244 0 -384 158t-140 416zM342 552q0 -180 68 -277t202 -97q133 0 200 97t67 278q0 183 -67 279t-202 96q-133 0 -200.5 -96.5t-67.5 -279.5zM533 1248l171 383h299 l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1222,
    d: "M81 553q0 266 140 419.5t395 153.5q246 0 385.5 -156.5t139.5 -416.5q0 -263 -141 -418.5t-395 -155.5q-244 0 -384 158t-140 416zM257 1248l250 383h208l251 -383h-184l-174 218l-172 -218h-179zM342 552q0 -180 68 -277t202 -97q133 0 200 97t67 278q0 183 -67 279 t-202 96q-133 0 -200.5 -96.5t-67.5 -279.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1222,
    d: "M81 553q0 266 140 419.5t395 153.5q246 0 385.5 -156.5t139.5 -416.5q0 -263 -141 -418.5t-395 -155.5q-244 0 -384 158t-140 416zM268 1248q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21q47 0 47 84h147q0 -35 -2 -62t-12 -62.5 t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45q-49 0 -50 -90h-144zM342 552q0 -180 68 -277t202 -97q133 0 200 97t67 278q0 183 -67 279t-202 96q-133 0 -200.5 -96.5t-67.5 -279.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1222,
    d: "M81 553q0 266 140 419.5t395 153.5q246 0 385.5 -156.5t139.5 -416.5q0 -263 -141 -418.5t-395 -155.5q-244 0 -384 158t-140 416zM302 1248v254h195v-254h-195zM342 552q0 -180 68 -277t202 -97q133 0 200 97t67 278q0 183 -67 279t-202 96q-133 0 -200.5 -96.5 t-67.5 -279.5zM723 1248v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 1456,
    d: "M178 489v187h1096v-187h-1096zM590 21v260h275v-260h-275zM590 875v259h284v-259h-284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1193,
    d: "M71 550q0 260 138.5 414.5t391.5 154.5q106 0 199 -30l94 180l69 -23l-93 -187q125 -66 190 -197.5t65 -309.5q0 -256 -138 -412t-392 -156q-107 0 -192 30l-101 -229l-62 34l96 222q-129 66 -197 199t-68 310zM318 551q0 -221 102 -320l301 682q-53 27 -123 27 q-134 0 -207 -101.5t-73 -287.5zM482 188q50 -25 117 -25q135 0 207 102t72 286q0 218 -95 316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1163,
    d: "M106 400v699h263v-689q0 -123 51.5 -178t163.5 -55q110 0 160.5 54.5t50.5 178.5v689h262v-699q0 -206 -131 -313.5t-345 -107.5t-344.5 107t-130.5 314zM169 1631h306l188 -383h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1163,
    d: "M106 400v699h263v-689q0 -123 51.5 -178t163.5 -55q110 0 160.5 54.5t50.5 178.5v689h262v-699q0 -206 -131 -313.5t-345 -107.5t-344.5 107t-130.5 314zM504 1248l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1163,
    d: "M106 400v699h263v-689q0 -123 51.5 -178t163.5 -55q110 0 160.5 54.5t50.5 178.5v689h262v-699q0 -206 -131 -313.5t-345 -107.5t-344.5 107t-130.5 314zM227 1248l250 383h208l251 -383h-184l-174 218l-172 -218h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1163,
    d: "M106 400v699h263v-689q0 -123 51.5 -178t163.5 -55q110 0 160.5 54.5t50.5 178.5v689h262v-699q0 -206 -131 -313.5t-345 -107.5t-344.5 107t-130.5 314zM273 1248v254h195v-254h-195zM694 1248v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1116,
    d: "M-6 1099h280l289 -797q32 119 143.5 442t122.5 355h280q-457 -1208 -461 -1218q-71 -185 -179 -264.5t-278 -79.5q-64 0 -136 8l-13 203q46 -5 117 -5q91 0 146 36t91 128q4 10 40 113zM474 1248l171 383h299l-315 -383h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1288,
    d: "M155 1498h230v-560q27 39 116.5 86.5t209.5 47.5q121 0 216.5 -43t155.5 -118.5t91.5 -174.5t31.5 -215q0 -89 -18 -168t-56.5 -147.5t-94 -118t-135.5 -78t-176 -28.5q-72 0 -136.5 16.5t-105.5 40.5t-65.5 44.5t-33.5 35.5v-549h-225v1636zM384 531q0 -163 76 -259 t234 -96q75 0 130.5 28.5t87.5 79t47.5 112.5t15.5 135t-15.5 134.5t-47 112t-87 79t-129.5 28.5q-156 0 -234 -96.5t-78 -257.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1116,
    d: "M-6 1099h280l289 -797q32 119 143.5 442t122.5 355h280q-457 -1208 -461 -1218q-71 -185 -179 -264.5t-278 -79.5q-64 0 -136 8l-13 203q46 -5 117 -5q91 0 146 36t91 128q4 10 40 113zM243 1248v254h195v-254h-195zM664 1248v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2176,
    d: "M81 738q1 214 96 386.5t261 269t371 96.5q203 0 359 -106v77h933l-18 -205h-658v-393h627v-202h-627v-452h705l-17 -205h-945v81q-67 -47 -160.5 -75.5t-192.5 -28.5q-213 0 -381 97t-260.5 269.5t-92.5 390.5zM343 735q0 -110 29 -207t85.5 -173.5t148 -121.5t207.5 -45 q113 0 206.5 33.5t148.5 83.5v848q-130 130 -357 130q-89 0 -165 -29.5t-131 -81t-94 -121t-58 -150t-20 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 1880,
    d: "M69 552q0 123 32.5 225t96 179.5t165.5 120.5t233 43q137 0 237 -51t159 -142q112 190 388 193q92 0 166.5 -27t125 -74.5t84.5 -114.5t49.5 -146t15.5 -171q0 -11 -0.5 -31.5t-1 -37t-0.5 -18.5h-709q3 -163 83.5 -252.5t223.5 -89.5q170 0 305 103l72 -155 q-79 -61 -168.5 -94t-215.5 -33q-304 0 -420 198q-55 -91 -157 -144.5t-238 -53.5q-130 0 -232.5 45.5t-165.5 124.5t-95.5 181.5t-32.5 221.5zM316 551q0 -181 75.5 -287.5t203.5 -106.5t204 106t76 289q0 188 -74.5 289t-206.5 101q-130 0 -204 -103.5t-74 -287.5z M1113 646h475v10q-1 286 -224 286q-45 0 -85 -15.5t-76 -48t-60 -92.5t-30 -140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1256,
    d: "M-15 1465h294l349 -634l351 634h290l-505 -879v-586h-272v581zM318 1608v254h195v-254h-195zM739 1608v254h196v-254h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 775,
    d: "M47 1163l250 383h208l251 -383h-184l-174 218l-172 -218h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 786,
    d: "M46 1230q0 36 2.5 65t13 63t28.5 57t50.5 38.5t77.5 15.5q58 0 129 -21t124 -42t68 -21q47 0 47 84h147q0 -35 -2 -62t-12 -62.5t-26.5 -58.5t-49 -39.5t-76.5 -16.5q-59 0 -178 45t-149 45q-49 0 -50 -90h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 995
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1991
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 995
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1991
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 663
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 497
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 331
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 331
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 248
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 398
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 110
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 677,
    d: "M70 445v204h536v-204h-536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 677,
    d: "M70 445v204h536v-204h-536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 677,
    d: "M70 445v204h536v-204h-536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1271,
    d: "M89 461v185h1099v-185h-1099z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2151,
    d: "M30 461v185h2086v-185h-2086z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 442,
    d: "M60 973l159 493h167l-108 -493h-218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 442,
    d: "M60 973l108 493h218l-159 -493h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 557,
    d: "M116 -280l108 492h220l-159 -492h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 953,
    d: "M176 973l160 493h159l-100 -493h-219zM477 973l148 493h170l-108 -493h-210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 953,
    d: "M176 973l108 493h210l-148 -493h-170zM476 973l100 493h219l-160 -493h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 1005,
    d: "M158 -280l111 492h231l-169 -492h-173zM512 -280l118 492h225l-163 -492h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 995,
    d: "M143 692q0 146 103.5 245.5t256.5 99.5q152 0 252.5 -96.5t100.5 -241.5q0 -147 -102.5 -245.5t-256.5 -98.5t-254 96t-100 241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 398
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 584,
    d: "M55 568l272 397h202l-261 -397l254 -394h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 584,
    d: "M56 174l260 395l-253 396h200l268 -396l-274 -395h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 497
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 1210,
    d: "M78 811l27 146h118q22 110 67.5 201.5t115 163.5t170.5 112.5t224 40.5q203 0 331 -128l-47 -195q-52 73 -124.5 111t-151.5 38q-137 0 -237.5 -94.5t-119.5 -248.5h568l-26 -147h-567q0 -5 -1 -41.5t-1 -69.5l-1 -33h561l-21 -152h-517q29 -161 124 -252t232 -91 q161 0 312 122l-1 -208q-151 -106 -340 -106q-127 0 -227.5 43t-165.5 119.5t-105 169t-58 203.5h-136l23 152h93q0 2 0.5 31.5t0.5 31.5q0 5 1 40.5t1 40.5h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1822,
    d: "M70 1470h665v-146h-246v-657h-167v657h-251zM801 667v803h216l218 -547l228 547h200v-803h-161v549l-222 -531h-105l-210 525v-543h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1100,
    d: "M0 0v1100h1100v-1100h-1100z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "b",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: ",",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201D",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -190
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "g",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "f",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quotedblright",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "comma",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "period",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "comma",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "period",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y,yacute,ydieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y,yacute,ydieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "period",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "W",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y,Yacute,Ydieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "period",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "period",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "period",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "D,E,F,H,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Ntilde,Thorn",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "comma",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "g",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "period",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "s",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "w",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "b",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "y,yacute,ydieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde",
    g2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde",
    g2: "y,yacute,ydieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "w",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "period",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "g",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "period",
    k: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxygenBold);
export default __webpack_public_path__ + "static/media/oxygen-bold.b3d1c1cedfb1a4135aea32bbee222af0.svg";
export { ForwardRef as ReactComponent };